<template>
  <div class="client-sidebar-nav" v-if="isVisible">
    <div class="menu-item">
      <router-link to="/dashboard" custom v-slot="{ href, navigate }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isClientDashboardActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-element-11 text-primary fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
            </i>
          </span>
          <span class="menu-title">{{ canWork ? 'Tablou Client' : 'Prima pagina' }}</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7">Vanzari</span>
      </div>
    </div>

    <div class="menu-item">
      <router-link to="/intrari/facturi" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-file-down text-warning fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span>
          <span class="menu-title">Facturi Intrare</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/facturare" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-file-up text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span>
          <span class="menu-title">Facturi Iesire</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/facturare/fp" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-document text-info fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span>
          <span class="menu-title">Factura Proforma</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/incarcari" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-folder-up text-primary fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span>
          <span class="menu-title">Documente</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/plan-conturi" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-chart-simple-3 text-dark fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
            </i>
          </span>
          <span class="menu-title">Plan Conturi</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link :to="$gate?.isPfa() ? '/registru-incasari-plati' : '/registru-jurnal'" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-book-open text-success fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
              <span class="path4"></span>
            </i>
          </span>
          <span class="menu-title">{{ $gate?.isPfa() ? 'Registru Încasări și Plăți' : 'Registru Jurnal' }}</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item pt-5">
      <div class="menu-content">
        <span class="menu-heading fw-bold text-uppercase fs-7">Setari & Cont</span>
      </div>
    </div>

    <div class="menu-item">
      <router-link to="/firmele-mele" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-briefcase text-warning fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span>
          <span class="menu-title">Firmele Mele</span>
        </a>
      </router-link>
    </div>

    <div class="menu-item">
      <router-link to="/contul-meu" custom v-slot="{ href, navigate, isActive }">
        <a :href="href" @click="navigate" class="menu-link" :class="{ 'active': isActive }">
          <span class="menu-icon">
            <i class="ki-duotone ki-user text-primary fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span>
          <span class="menu-title">Contul Meu</span>
        </a>
      </router-link>
    </div>

  </div>
</template>

<script>
import { useUserStore } from '../../../stores/user';

export default {
  name: 'ClientSidebarMenu',
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  computed: {
    canWork() {
      if (this.$gate && typeof this.$gate.canWorkOnFirms === 'function') {
        return this.$gate.canWorkOnFirms();
      }
      return this.$gate?.isAdmin() || false;
    },
    isClientDashboardActive() {
      const p = this.$route?.path;
      return (p === '/dashboard' || p === '/') && this.$route?.query?.view !== 'contabil';
    },
    isContabilDashboardActive() {
      const p = this.$route?.path;
      return p === '/administrare/dashboard' ||
             ((p === '/dashboard' || p === '/') && this.$route?.query?.view === 'contabil');
    },
    isVisible() {
      if (!this.canWork) return true;

      const mode = this.userStore.currentSidebarMode || 'tot';
      return mode === 'client' || mode === 'tot';
    }
  }
};
</script>
